import classNames from 'classnames';
import { CSSProperties, ForwardedRef, ReactElement } from 'react';

import GridList, { GridListProps } from './GridList';
import { ListItem } from './List';

import styles from '../../styles/lists/responsive-list.module.css';

export interface ResponsiveListProps<T = ListItem> extends GridListProps<T> {
    withoutScrollSnap?: boolean;
}

// A grid that becomes a horizontally scrolling row on touch screens. The switch is made in CSS
// (`--touch-screen` media query) so the server and the client always render the same markup.
function ResponsiveList<T = ListItem>({
    cardWidth = null,
    withoutScrollSnap = false,
    className = null,
    itemsClassName = null,
    itemsStyle = null,
    itemClassName = null,
    ref: listRef = null,
    ...props
}: ResponsiveListProps<T> & { ref?: ForwardedRef<HTMLDivElement> | null }) {
    return (
        <GridList<T>
            {...props}
            ref={listRef}
            cardWidth={cardWidth}
            className={classNames([
                styles.container,
                'drag-disabled',
                {
                    [styles.scrollSnap]: !withoutScrollSnap,
                },
                className,
            ])}
            itemsClassName={classNames([styles.items, itemsClassName])}
            itemsStyle={
                cardWidth !== null
                    ? ({
                          ...itemsStyle,
                          '--list-row-card-width': `${cardWidth}px`,
                      } as CSSProperties)
                    : itemsStyle
            }
            itemClassName={classNames([styles.item, itemClassName])}
        />
    );
}

export default ResponsiveList as <T = ListItem>(
    props: ResponsiveListProps<T> & { ref?: ForwardedRef<HTMLDivElement> },
) => ReactElement;
